.cell {
    display: flex;
    flex-direction: column;
}

.cellRow {
    display: flex;
    height: 75px;
}

.bottomCellRow {
    display: flex;
    margin-top: auto; /* Keeps spacing consistent for the Target Residual Risk cell, which has no trend line chart taking up vertical space. */
}

.totalAndTrend {
    display: flex;
    align-items: center;
}

.trendArrowUp {
    color: var(--hps-red);
    height: 1.563rem; /* Matches the font size for the Text1 variant. */
    margin-left: 5px;
}

.trendArrowDown {
    color: var(--hps-dark-green);
    height: 1.563rem; /* Matches the font size for the Text1 variant. */
    margin-left: 5px;
}

.headerAndInfo {
    display: flex;
    flex-direction: column;
    width: 50%;
}

.trendLineChart {
    height: 60px;
}